import React from 'react';
import ConfirmationModal from '../../../../Base/Components/Confirmation/ConfirmationModal';
import { BaseModalProps } from '../../../../Base/Components/BaseModal/BaseModal';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';

interface Props extends BaseModalProps {
	onSubmit: () => void;
}

const EArchiveGroupsListDeleteModal = (props: Props) => {
	return (
		<ConfirmationModal
			{...props}
			title={'component.eArchive.groups.deleteGroupConfirmationTitle'}
			text={'component.eArchive.groups.deleteGroupConfirmationText'}>
			<Button
				title={'base.shared.confirm'}
				theme={Theme.GREEN}
				onClick={props.onSubmit}
			/>
		</ConfirmationModal>
	);
};

export default EArchiveGroupsListDeleteModal;
